<template lang="html">
  <!-- Modal 5-->
  <div class="modal fade" id="aptamil3-plus" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4">
              <h3>Aptamil 3+</h3>
              <p class="text-center">Lapte premium fortifiat 3 ani+</p>
              <img class="img-fluid" src="../../../assets/images/pentru-imunitate/item3.png">
            </div>
            <div class="col-lg-8">
              <div class="scroll-vertical-band">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="home3plus-tab" data-toggle="tab"
                       href="#home3plus" role="tab" aria-controls="home3plus" aria-selected="true">Listă
                      ingrediente</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="profile3plus-tab" data-toggle="tab" href="#profile3plus"
                       role="tab" aria-controls="profile3plus" aria-selected="false">Ghid de
                      alimentație</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="contact3plus-tab" data-toggle="tab" href="#contact3plus"
                       role="tab" aria-controls="contac3plust" aria-selected="false">Declarație
                      nutrițională</a>
                  </li>
                </ul>
              </div>
              <div class="tab-content" id="myTabContent3plus">
                <div class="tab-pane fade show active" id="home3plus" role="tabpanel"
                     aria-labelledby="home3plus-tab">
                  <p>Lactoză (din <strong>lapte</strong> de vacă),<strong> lapte</strong> de vacă degresat, maltodextrină, galactooligozaharide (din <strong>lapte</strong> de vacă), produs din zer [(zer demineralizat, concentrat din zer) (din <strong>lapte</strong> de vacă)],
                    ulei de rapiță, ulei de floarea soarelui, ulei de floarea soarelui bogat în acid oleic, ulei de cocos, fosfat tricalcic, fructooligozaharide, carbonat de calciu, ulei de <strong>pește</strong>, citrat de potasiu, magneziu hidrogen fosfat, citrat de sodiu,
                    clorură de potasiu, acid L-ascorbic, emulsifiant (lecitine (<strong>soia</strong>)), clorură de colină, sulfat feros, inozitol, clorură de magneziu, L-ascorbat de sodiu, sulfat de zinc, antioxidant (ascorbil palmitat), D-pantotenat de calciu, DL-alfa-tocoferil
                    acetat, aromă (<strong>lapte</strong>), nicotinamidă, riboflavină, retinil palmitat, colecalciferol, hidroclorură de piridoxină, hidroclorură de tiamină, iodură de potasiu, acid pteroilmonoglutamic, fitomenadionă, D-biotină, cianocobalamină.</p>
                </div>
                <div class="tab-pane fade" id="profile3plus" role="tabpanel"
                     aria-labelledby="profile3plus-tab">
                  <ol>
                    <li>Spală-te bine pe mâini, sterilizează toate ustensilele utilizate în prepararea laptelui și asigură-te că marginea ambalajului este curată.</li>
                    <li>Fierbe apa potabilă pentru prepararea laptelui timp de 5 minute, apoi lasă la răcit până la cca 40°C.Toarnă în recipientul pregătit (cănuță) cantitatea de apă fiartă şi răcită, necesară conform dozării pentru o masă.</li>
                    <li>Dozează pudra cu linguriţa din capacul ambalajului, nivelată cu ajutorul marginii din interiorul cutiei. Adaugă pudra conform tabelului de dozare în recipientul pregătit (cănuță).</li>
                    <li>Închide recipientul şi agită vertical și viguros timp de 10 secunde. Este foarte important să respecți modalitatea și timpul de agitare pentru a dizolva corect pudra.</li>
                    <li>Verifică pe încheietura mâinii tale temperatura laptelui preparat (cca 37°C).</li>
                  </ol>
                </div>
                <div class="tab-pane fade box-shadow" id="contact3plus" role="tabpanel"
                     aria-labelledby="contact3plus-tab">
                  <div class="row height-row">
                    <div class="col-md-4 col-4 border-table">
                      <span class="span-black pl-0">Declarație nutrițională</span>
                    </div>
                    <div class="col-md-4 col-4 border-table"><span
                        class="span-black">100 g pudră</span></div>
                    <div class="col-md-4 col-4 border-table border-last"><span class="span-black">la 100 ml lapte reconstituit (13 g pudră)</span>
                    </div>

                  </div>
                  <valoare></valoare>
                  <grasimi></grasimi>
                  <glucide></glucide>
                  <polioli></polioli>
                  <fibre></fibre>
                  <proteine></proteine>
                  <sare></sare>
                  <vitamine></vitamine>
                  <alte></alte>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Grasimi from "./Table/grasimi";
import Valoare from "./Table/valoare";
import Glucide from "./Table/glucide";
import Polioli from "./Table/polioli";
import Fibre from "./Table/fibre";
import Proteine from "./Table/proteine";
import Sare from "./Table/sare";
import Vitamine from "./Table/vitamine";
import Alte from "./Table/alte";

export default {
  components: {
    Grasimi,
    Valoare,
    Glucide,
    Polioli,
    Fibre,
    Proteine,
    Sare,
    Vitamine,
    Alte,
  },
  data() {
    return {}
  },
}
</script>

<style lang="css">
</style>
